/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiDefSupportReport } from '../../models/api-def-support-report';
import { ApiDefSupportReportUpdateRequest } from '../../models/api-def-support-report-update-request';

export interface OrganizationsUpdateSupportReport$Params {
  organizationId: string;
  reportId: string;
      body: ApiDefSupportReportUpdateRequest
}

export function organizationsUpdateSupportReport(http: HttpClient, rootUrl: string, params: OrganizationsUpdateSupportReport$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiDefSupportReport>> {
  const rb = new RequestBuilder(rootUrl, organizationsUpdateSupportReport.PATH, 'patch');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.path('reportId', params.reportId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiDefSupportReport>;
    })
  );
}

organizationsUpdateSupportReport.PATH = '/organizations/{organizationId}/support/{reportId}';
